import type { AppPage, Spread } from '@lilith-arcana-os/domain';
import { ALL_SPREAD_DEFINITIONS, ALL_SPREADS } from '@lilith-arcana-os/spread-registry/derived/all-spreads';
import { FULL_DECK_CORE } from '@lilith-arcana-os/tarot-corpus/derived/full-deck';

export const bootstrapSpreadDefinitions = ALL_SPREAD_DEFINITIONS;
export const bootstrapSpreads: Spread[] = ALL_SPREADS;

export const navigationPages: Array<{ id: AppPage; label: string }> = [
  { id: 'home', label: 'Home' },
  { id: 'reading', label: 'Nuova lettura' },
  { id: 'library', label: 'Biblioteca' },
  { id: 'history', label: 'Archivio' },
  { id: 'settings', label: 'Impostazioni' },
];

export const bootstrapDeckIds = FULL_DECK_CORE.map((card) => card.id);
